export const useNumber = () => {
  /**
    * Generates a random number from min (inclusive) and max (exclusive)
    */
  const randomNumber = (min, max) => (Math.random() * (max - min)) + min;

  return {
    randomNumber,
  };
};
